import { apiClient } from './client';
import type { LoginCredentials, RegisterData } from '@/types';

/**
 * Cookie-auth endpoints (Wave 2.4). These set httpOnly session/refresh cookies +
 * a JS-readable CSRF cookie on the response and return only `{ ok: true }`. The
 * builder never sees the token — it hydrates identity from GET /auth/me afterwards
 * (see useAuthStore.hydrate).
 */

export async function login(credentials: LoginCredentials): Promise<void> {
  await apiClient.post('/auth/login/cookie', credentials);
}

export async function register(data: RegisterData): Promise<void> {
  await apiClient.post('/auth/register/cookie', data);
}

export async function logout(): Promise<void> {
  try {
    await apiClient.post('/auth/logout/cookie');
  } catch {
    // Ignore errors on logout — cookies are cleared client-side regardless.
  }
}

/**
 * Public password-reset flow (no auth). Request emails a 6-digit code; reset
 * consumes it. The request call always succeeds server-side (no account enumeration).
 */
export async function passwordResetRequest(email: string): Promise<void> {
  await apiClient.post('/auth/password-reset-request', { email });
}

export async function passwordReset(email: string, code: string, password: string): Promise<void> {
  await apiClient.post('/auth/password-reset', { email, code, password });
}
